import { createSlice, configureStore } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

interface UserState {
    logined: boolean;
    keys?: {
        publicKey: string;
        privateKey: string;
    };
}

const userSlice = createSlice({
    name: 'user',
    initialState: {
        logined: false,
        keys: undefined
    } as UserState,
    reducers: {
        setLogined: (state: UserState, action: PayloadAction<boolean>) => {
            state.logined = action.payload;
        },
        setKeys: (state: UserState, action: PayloadAction<{
            publicKey: string;
            privateKey: string;
        } | undefined>) => {
            state.keys = action.payload;
        }
    }
});

const store = configureStore({
    reducer: userSlice.reducer
});

export function getUserState(): UserState {
    return store.getState();
}

export function setLogined(logined: boolean, keys?: {
    publicKey: string;
    privateKey: string;
}) {
    store.dispatch(userSlice.actions.setLogined(logined));
    store.dispatch(userSlice.actions.setKeys(keys));
}
